import {
  normalizeOperationalModality,
  operationalModalityBadgeClassList,
} from '../utils/operationalConsoleUi';
import { MODALITY } from '../utils/chipContract';

export default function OperationalModalityBadge({ modality, title, className = '' }) {
  const safe = normalizeOperationalModality(modality);
  const chip = MODALITY[safe] || { emoji: '📜', label: safe.toUpperCase() };
  return (
    <span
      className={`${operationalModalityBadgeClassList(safe)} ai-status--emoji${className ? ` ${className}` : ''} ai-status--icon`}
      title={title ?? `Модальность: ${chip.label}`}
    >
      {chip.emoji}
    </span>
  );
}
